import { Route, Routes } from "react-router-dom";
import Drives from './DrivesPage';
import DetailPage from "./DetailPage";
import DriveWorkspace from "./pages/DriveWorkspace";
import { DrivesProvider } from "./provider/drives.provider";

const DrivesPage = () => {
    return (
        <DrivesProvider>
            <Routes path="drives/*">
                <Route index element={<Drives />} />
                <Route path="my-workspace" element={<Drives />} />
                <Route path="shared-with-me" element={<Drives />} />
                <Route path="d/:vaultUuid/*" element={<DriveWorkspace />} />
                <Route path="*" element={<DetailPage />} />
            </Routes>
        </DrivesProvider>
    );
};

export default DrivesPage;